import { Box, Container, Grid, Typography } from '@mui/material';
import React from 'react';
import Typical from 'react-typical'
import banner from '../../../images/homeBanner.png'
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import EmailIcon from '@mui/icons-material/Email';

const HomeBanner = () => {
    return (
        <Container style={{marginTop: 75}}>
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                <Grid item xs={12} sm={12} md={6} style={{display: 'flex', justifyContent: 'center', flexDirection: 'column'}}>
                    <Typography style={{fontWeight: 500, marginBottom: '1px', fontSize: '350%'}} variant="h2" component="div" gutterBottom>
                    I am <span style={{color: '#92e3a9'}}>Mahadi Hassan Riyadh</span>,
                    </Typography>
                    <Typography style={{fontWeight: 500, marginTop: '1px', fontSize: '200%'}} variant="h2" component="div" gutterBottom>
                        <Typical style={{margin: '0px', color: '#263238'}}
                            steps={['A Web Developer', 1500, 'A React Developer', 1000, 'A Mern Stack Developer', 1500]}
                            loop={Infinity}
                            wrapper="span"
                        />
                    </Typography>
                    <Box>
                        <a style={{ textDecoration: 'none', color: '#263238', marginRight: 20}} href="https://www.linkedin.com/in/mahadihassanriyadh/"><LinkedInIcon style={{ fontSize: 40 }} /></a>
                        <a style={{ textDecoration: 'none', color: '#263238', marginRight: 20}} href="https://github.com/mahadihassanriyadh"><GitHubIcon style={{ fontSize: 40 }} /></a>
                        <a style={{ textDecoration: 'none', color: '#263238' }} href="mailto:mahadihassanriyadh1@gmail.com"><EmailIcon style={{ fontSize: 40 }} /></a>
                    </Box>
                    
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                    <img src={banner} style={{width: '100%'}} alt="" />
                </Grid>
            </Grid>
        </Container>
    );
};

export default HomeBanner;